export default __webpack_public_path__ + "static/media/gigglwaifu.1485ba7f.png";